import classNames from 'classnames';
import styles from '../styles.module.scss';

const loginLink = ({link: {id, onClick, text, href}}) => {
  return (
    <a href={href} className={classNames(styles.linkStyles)} onClick={event => onClick(event)} id={id}>
      {text}
    </a>
  );
};

export default loginLink;
